import { render } from "./BlocRevue.vue?vue&type=template&id=416c5172"
import script from "./BlocRevue.vue?vue&type=script&lang=js"
export * from "./BlocRevue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__